import { render, staticRenderFns } from "./item-list.vue?vue&type=template&id=2caf0642&scoped=true&"
import script from "./item-list.vue?vue&type=script&lang=js&"
export * from "./item-list.vue?vue&type=script&lang=js&"
import style0 from "./item-list.vue?vue&type=style&index=0&id=2caf0642&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf0642",
  null
  
)

export default component.exports